export default "__VITE_ASSET__CVAxh_Sb__"